// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// legal pages
const TermsAndConditions = Loadable(() => import('views/pages/terms/TermsAndConditions'));
const OpenSourceLicenses = Loadable(() => import('views/pages/openSource/OpenSourceLicenses'));

// login routing
const AuthLogin = Loadable(() => import('views/pages/authentication/Login'));
const AuthRegister = Loadable(() => import('views/pages/authentication/Register'));
const AuthForgotPassword = Loadable(() => import('views/pages/authentication/ForgotPassword'));
const AuthResetPassword = Loadable(() => import('views/pages/authentication/ResetPassword'));
const AuthCheckMail = Loadable(() => import('views/pages/authentication/CheckMail'));
const AuthCodeVerification = Loadable(() => import('views/pages/authentication/CodeVerification'));
const TrustBrowser = Loadable(() => import('views/pages/authentication/TrustBrowser'));
const VerifyEmail = Loadable(() => import('views/pages/authentication/VerifyEmail'));
import LandingPage from '../landingPage';
import MUISupport from '../muiSupport';
import FailSafeSupport from '../failSafeSupport';
import CamSDK from '../CamSDk';
import AccountSelectionPage from '../views/pages/accountSelection/AccountSelectionPage';
import PremiumUser from '../premiumUser';
import AuthPortalRedirect from '@/components/AuthPortalRedirect';
import Enable2FA from '../views/pages/authentication/Enable2FA';
import TwoFactorMethodSelection from '../views/pages/authentication/TwoFactorMethodSelection';
import TwoFactorAuthVerification from '../views/pages/authentication/TwoFactorAuthVerification';
const TwoFactorSuccess = Loadable(() => import('../views/pages/authentication/TwoFactorSuccess'));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: '/',
      element: <CamSDK />
    },
    {
      path: '/landingPage',
      element: <LandingPage />
    },
    {
      path: '/account-selection',
      element: <AccountSelectionPage />
    },
    {
      path: '/muiSupport',
      element: <MUISupport />
    },
    {
      path: '/failSafeSupport',
      element: <FailSafeSupport />
    },
    {
      path: '/premiumUser',
      element: <PremiumUser />
    },
    {
      path: '/forgot-password',
      element: <AuthForgotPassword />
    },
    {
      path: '/reset-password',
      element: <AuthResetPassword />
    },
    {
      path: '/check-mail',
      element: <AuthCheckMail />
    },
    {
      path: '/code-verification',
      element: <AuthCodeVerification />
    },
    {
      path: '/otp-login',
      element: <AuthPortalRedirect type="login" />
    },
    {
      path: '/trust-browser',
      element: <TrustBrowser />
    },
    {
      path: '/confirmemail',
      element: <VerifyEmail />
    },
    {
      path: '/enable2fa',
      element: <AuthPortalRedirect type="login" />
    },
    {
      path: '/twoFactorMethodSelection',
      element: <AuthPortalRedirect type="login" />
    },
    {
      path: '/twoFactorVerification',
      element: <AuthPortalRedirect type="login" />
    },
    {
      path: '/twoFactorSuccess',
      element: <AuthPortalRedirect type="login" />
    },
    {
      path: '/terms',
      element: <TermsAndConditions />
    },
    {
      path: '/openSource',
      element: <OpenSourceLicenses />
    }
  ]
};

export default LoginRoutes;
